import { useCallback, useEffect, useMemo, useState } from 'react'

/** Separate from mutation selection: DMS source actions can select provider-managed files. */
export type SyncedFileSelection = {
  selectedFileIds: string[]
  selectedCount: number
  isFileSelected: (fileId: string) => boolean
  toggleFileSelect: (fileId: string) => void
  clearSelection: () => void
}

export function useSyncedFileSelection(resetKey: string | null): SyncedFileSelection {
  const [selectedFileIds, setSelectedFileIds] = useState<string[]>([])

  useEffect(() => {
    setSelectedFileIds([])
  }, [resetKey])

  const selectedFileIdSet = useMemo(() => new Set(selectedFileIds), [selectedFileIds])

  const isFileSelected = useCallback((fileId: string) => selectedFileIdSet.has(fileId), [selectedFileIdSet])

  const toggleFileSelect = useCallback((fileId: string) => {
    setSelectedFileIds((current) => (current.includes(fileId) ? current.filter((id) => id !== fileId) : [...current, fileId]))
  }, [])

  const clearSelection = useCallback(() => setSelectedFileIds([]), [])

  return { selectedFileIds, selectedCount: selectedFileIds.length, isFileSelected, toggleFileSelect, clearSelection }
}
